package com.milta.core.localization.translations.en

import com.milta.core.localization.AppStrings

val EnStrings = AppStrings(
    common = Common,
    auth = Auth,
    errors = Errors,
    home = Home,
    profile = Profile,
    subscription = Subscription,
    route = Route,
    team = Team,
    subscriptionExpired = SubscriptionExpired,
    imports = Imports,
    ocrScan = OcrScan,
    spreadsheetImport = SpreadsheetImport,
    webImportRoute = WebImportRoute,
    loadingAddress = LoadingAddress,
    unlocatedDelivery = UnlocatedDelivery,
    routeCreation = RouteCreation,
    settings = Settings,
    webDashboard = WebDashboard,
    webHistorique = WebHistorique,
    adminUsers = AdminUsers,
    adminPrompts = AdminPrompts,
    adminOcrAnalysis = AdminOcrAnalysis,
    optimizationQuota = OptimizationQuota,
    aiCredit = AiCredit,
    publicPages = PublicPages,
)
